import React from "react";
import { StyledCarouselBody, StyledCarouselImage, StyledLeftArrow } from "./style";
import { ArrowInterface, CarouselBodyInterface } from "../../ducks/types";
import { bestSoftwareAward, searchAwardEurope, searchAwardUS, searchSoftwareAward } from "../../../app/icons";

const awardList: [string[]] = [
    [searchAwardEurope, bestSoftwareAward, searchSoftwareAward, searchAwardUS]
];

export const LeftArrow: React.FC<ArrowInterface> = ({ param, clickArrow, disable }) => {
    return (
        <StyledLeftArrow onClick={() => clickArrow(param)} disabled={disable}>
            <span>{"<"}</span>
        </StyledLeftArrow>
    );
};

export const RightArrow: React.FC<ArrowInterface> = ({ param, clickArrow, disable }) => {
    return (
        <StyledLeftArrow onClick={() => clickArrow(param)} disabled={disable}>
            <span>{">"}</span>
        </StyledLeftArrow>
    );
};

export const CarouselBody: React.FC<CarouselBodyInterface> = ({ awardsListIndex }) => {
    return (
        <>
            <StyledCarouselBody>
                {awardList[awardsListIndex].map((item: string, index: number) => {
                    return <StyledCarouselImage src={item} key={index} />;
                })}
            </StyledCarouselBody>
        </>
    );
};
